import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PAGINAS, ROUTES, FUNCIONALIDADES } from '../../../routes';
import { CadastroBasicoNomeSituacaoForm } from '../components/CadastroBasicoNomeSituacaoForm';
import { getTipoAtendimento, cadastrarTipoAtendimento, alterarTipoAtendimento, excluirTipoAtendimento } from './tipos_atendimentos.service';
export var TiposAtendimentosAlterar = function () {
    return (_jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_ATENDIMENTOS, paginaPermissao: FUNCIONALIDADES.TIPOS_ATENDIMENTOS, rota: ROUTES.TIPOS_ATENDIMENTOS, services: {
            getItem: getTipoAtendimento,
            cadastrarItem: cadastrarTipoAtendimento,
            alterarItem: alterarTipoAtendimento,
            excluirItem: excluirTipoAtendimento,
        } }));
};
export default TiposAtendimentosAlterar;
